export default __webpack_public_path__ + "static/media/landscape2-MULTIPLY-shadows.92481fa6.png";